<template>
  <div id="esr" class="my-1">
    <div class="container w-75">
       <img class="rounded img-fluid h-100" src="/ESR.png" alt=""> 
    </div> 
    <main class="main-content border-radius-lg justify-content-center">
      <div class="container-fluid justify-content-center">
        <div class="row justify-content-center">
          <div class="col-sm-6 col-12 ">
            <div class="card z-index-2 h-100">
              <div class="card-header pb-0 pt-3">
                <h3>Empresa Socialmente Responsable</h3>
              </div>
              <div class="card-body p-3">
                <div class="justify-content-center" style="text-align: justify">
                  <small>{{ businessres }}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4 col-12 d-flex justify-content-center align-items-center">
            <img src="/arbol.jpg" class="rounded-3 w-100 h-100">
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
      
<script>
export default {
  name: "nutriendo",
  props: {
    businessres: {
      type: String,
      request: true,
    },
  },
};
</script>
  
<style lang="scss"  scoped>
.card{
  position: static;
}
</style>